import { CapacitorCookies } from '@capacitor/core';

const getCookie = async (name) => {
  const value = await CapacitorCookies.getCookies();
  return value[name];
};

const processFetch = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return await response.json();
  }

  throw new Error(response.status);
};

const commonHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json, text/plain, */*',
  'X-Requested-With': 'XMLHttpRequest',
};

const baseUrl = import.meta.env.VITE_API_URL;

export {
  getCookie,
  processFetch,
  commonHeaders,
  baseUrl,
};